import { Modal } from "react-bootstrap";
import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

import { BsQuestionLg } from "react-icons/bs";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";

export const ConfirmDefault = { show: false, action: null, title: "" };

export default function ConfirmDialogB(props) {
  const [winState, setState] = props.winState;
  const handleClose = (value) => {
    winState.action(value);
    setState({ show: false });
  };

  return (
    <MyModal show={winState && winState.show} centered>
      <ModalHeaderBlack>กรุณายืนยัน</ModalHeaderBlack>
      <ModalBodyBlack>
        <MsgBox>
          {winState && winState?.title}
          <BsQuestionLg
            size={30}
            style={{
              background: "#e93410",
              borderRadius: "15px",
              margin: "5px",
            }}
          />
        </MsgBox>
      </ModalBodyBlack>
      <ModalFooterBlack>
        <Button variant="primary" onClick={() => handleClose(true)}>
          ยืนยัน
        </Button>
        <Button variant="danger" onClick={() => handleClose(false)}>
          ยกเลิก
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}

const MsgBox = styled.p`
  font-size: large;
  color: var(--fore-primary);
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: var(--bg-primary);
`;

export const GetConfirmTitle = (type) => {
  switch (type) {
    case "DELETE":
      return "ยืนยันการลบรายการ";
    case "UPDATE":
      return "ยืนยันการแก้ไขรายการ";
    case "ACCEPT_CASE":
      return "ยืนยันการรับเคส";
    default:
      return "กรุณายืนยัน";
  }
};
